import { render, staticRenderFns } from "./inventory-loss.vue?vue&type=template&id=2baf0f08"
import script from "./inventory-loss.vue?vue&type=script&lang=js"
export * from "./inventory-loss.vue?vue&type=script&lang=js"
import style0 from "./inventory-loss.vue?vue&type=style&index=0&id=2baf0f08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports